export const en = {
  nav: {
    services: 'Services',
    portfolio: 'Portfolio',
    starModel: 'Star Model',
    partners: 'Partners',
    about: 'About',
    contact: 'Contact',
    getStarted: 'Get Started',
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
  },
  hero: {
    title: "Building Tomorrow's Business Excellence",
    subtitle: "Impresstars orchestrates high-performance business operations through our innovative Star Model system. From incorporation to growth strategy, we're your partner in operational excellence.",
    exploreServices: 'Explore Services',
    learnMore: 'Learn More',
  },
  services: {
    eyebrow: 'What we do',
    title: 'Our Services',
    incorporation: {
      title: 'Incorporation Services',
      description: 'Start your business right with our streamlined incorporation process. LLC, Corp, or Non-profit setup made simple.',
    },
    aiSolutions: {
      title: 'AI Solutions',
      description: 'Custom AI integration services including machine learning models, natural language processing, and automated decision systems.',
    },
    b2bSolutions: {
      title: 'B2B Solutions',
      description: 'Comprehensive B2B services including partnership development, supply chain optimization, and business process outsourcing.',
    },
    marketingStrategy: {
      title: 'Marketing Strategy',
      description: 'Data-driven marketing strategies tailored to your business goals, including market analysis and growth planning.',
    },
    businessSoftware: {
      title: 'Business Software',
      description: 'Identify and implement the right software solutions to streamline your operations and boost productivity.',
    },
    brandDesign: {
      title: 'Brand Design',
      description: 'Professional logo design, brand identity development, and marketing materials that make lasting impressions.',
    },
    businessConsulting: {
      title: 'Business Consulting',
      description: 'Strategic guidance to optimize your operations and accelerate growth through proven methodologies.',
    },
    ctaTitle: 'Ready to Transform Your Business?',
    ctaText: "Let's discuss how our services can help you achieve your goals.",
    ctaButton: 'Get Started',
  },
  starModel: {
    eyebrow: 'Connected by design',
    title: 'Star Models',
    description: 'Discover our ecosystem of specialized business units and the operating methodology behind them.',
    learnHow: 'Learn How the Star Model Works',
    captionLeft: 'Connected operations',
    captionRight: 'Shared momentum',
    cleaningEdge: {
      title: 'Cleaning EDGE',
      status: 'Active',
      description: 'Professional cleaning services reimagined through technology and exceptional service standards.',
      details: 'Cleaning EDGE is a professional cleaning company focused on dependable residential and commercial services, including post-construction cleaning and automotive detailing, with digital workflows that make booking, communication, and service follow-through easier.',
    },
    ozean: {
      title: 'Ozean',
      status: 'Development',
      description: 'A stock audio platform offering sound assets for creators, editors, brands, and storytellers.',
      details: 'Ozean is focused on curated stock audio, helping creative teams source tracks and sound elements for content production.',
    },
    visitWebsite: 'Visit Website',
  },
  testimonials: {
    eyebrow: 'Client stories',
    title: 'Client Testimonials',
    description: "Don't just take our word for it — hear what our clients have to say about working with Impresstars.",
    j94Designs: 'Impresstars supported us with HR consulting and also helped us build key parts of our Wix website.',
    craftPapi: 'Impresstars developed a practical marketing plan for our team, making our campaigns and priorities much clearer.',
    pawStuffs: 'Impresstars continues to support our Shopify site and provides ongoing service support as our store grows.',
  },
  portfolio: {
    eyebrow: 'Selected work',
    title: 'Our Portfolio',
    description: 'Explore our recent projects and success stories across various industries and services.',
    filterAll: 'All',
    filterWebsites: 'Websites',
    filterApps: 'Apps & Tools',
    filterGames: 'Games',
    filterConsulting: 'Consulting',
    production: 'Production',
    showcase: 'Showcase',
    viewCaseStudy: 'View Case Study',
    visitSite: 'Visit Site',
    openProject: 'Open Project',
    viewServices: 'View Our Services',
    startProject: 'Start a Project',
    filterAllProjects: 'All Projects',
    filterRealWorld: 'Production',
    filterShowcase: 'Showcase',
    sortFeatured: 'Featured',
    sortAZ: 'Title: A-Z',
    sortZA: 'Title: Z-A',
    sortLabel: 'Sort by:',
    reset: 'Reset',
    showing: 'Showing',
    of: 'of',
    projects: 'projects',
    noProjects: 'No projects found for this filter yet.',
    visitProjectWebsite: 'Visit project website',
    catBrandWebsite: 'Brand Website',
    catWebDevelopment: 'Web Development',
    catEcommerceWebsite: 'Ecommerce Website',
    catBusinessWebsite: 'Business Website',
    catWebsite: 'Website',
    catJewelleryBrand: 'Jewellery Brand',
    catWebApp: 'Web App',
    catInteractiveApp: 'Interactive App',
    catUtilityTool: 'Utility Tool',
    cat3DWebSandbox: '3D Web Sandbox',
    catWebGame: 'Web Game',
    catGameExperience: 'Game Experience',
    catConsultingMarketingPlan: 'Consulting & Marketing Plan',
    desc: {
      snouts: "Website work supporting Snouts' online brand presence.",
      innovaPro: 'Website delivery for Innova Pro focused on a clear service presentation and strong performance.',
      pawstuffs: 'Ecommerce web presence and storefront support for Pawstuffs.',
      cleaningEdge: 'Website and digital presence work for Cleaning EDGE.',
      cheesePanic: 'Cat chases mouse, mouse wants cheese. A chaotic little web game.',
      cleaningEdgeApp: 'Operations-focused, self-serve platform for Cleaning EDGE clients and workers. Test the dev demo with password cleaningEDGE, and make sure to select Legacy Mode.',
      angoloDiamonds: 'Website development work for Angolo Diamonds.',
      craftPapiGrowth: 'Consulting and marketing plan development for Craft Papi to strengthen positioning and growth execution.',
      roboticVoiceClicker: 'Voice-triggered clicker experience with playful lizard-button interaction.',
      cheatCounter: 'Jorge looked at the top card of his library again. Someone had to keep track.',
      klondikeSolitaire: 'Classic solitaire-inspired web game presentation and interaction design.',
      universeAdventure: 'Space adventure concept featuring galaxy travel and ship-based exploration.',
      interiorDesign3d: 'A Three.js browser sandbox to import 3D models and build interior scenes.',
      pavillionJewellery: 'Brand-forward website presentation for Pavillion Jewellery.',
      hauntedGalleria: 'An immersive, dark-themed showcase website for a haunted gallery experience with atmospheric visuals and eerie animations.',
    },
  },
  partners: {
    eyebrow: 'Trusted Technology',
    title: 'Tools We Use & Recommend',
    description: 'These are platforms we actively work with and recommend to our clients. If you sign up through our links, we may earn a referral — at no extra cost to you.',
    teaserEyebrow: 'Trusted Technology',
    teaserTitle: 'Tools We Recommend',
    seeAllPartners: 'See All Partners',
    getStarted: 'Get Started',
    ctaTitle: 'Need Help Choosing the Right Stack?',
    ctaText: 'We evaluate, implement, and integrate tools into your workflow. Let us handle the tech so you can focus on your business.',
    ctaButton: 'Talk to Us',
    disclaimer: 'Some links on this page are referral links. Impresstars may earn a commission if you sign up — at no extra cost to you.',
    catProductivity: 'Productivity',
    catAIVoice: 'AI & Voice',
    catBusinessPhone: 'Business Phone',
    catAIWebBuilder: 'AI Web Builder',
  },
  about: {
    eyebrow: 'Our purpose',
    title: 'About Impresstars',
    p1: 'At Impresstars, we believe in transforming business operations through innovation and excellence. Our mission is to help companies reach their full potential by implementing cutting-edge solutions and proven methodologies.',
    p2: 'Founded on the principles of operational excellence and sustainable growth, we\'ve developed our unique Star Model system that has helped numerous businesses achieve remarkable success.',
  },
  clients: {
    title: 'Our Clients',
    description: "We're proud to work with these organizations and help them grow through our services and dedicated support.",
  },
  techPlatforms: {
    title: 'Technologies & Platforms We Support',
    description: 'We can help with implementation, optimization, or support across these tools and platforms.',
    catEcommerce: 'E-commerce & Websites',
    catAI: 'AI & Automation',
    catMarketing: 'Marketing & Growth',
    catCloud: 'Cloud & Infrastructure',
    catCreative: 'Creative & Brand Production',
    focusEcommerce: 'Core competency: launching and supporting conversion-focused storefronts and business websites.',
    focusAI: 'Core competency: practical AI adoption and workflow automation for growing teams.',
    focusMarketing: 'Core competency: performance tracking, campaign execution, and foundational SEO.',
    focusCloud: 'Core competency: reliable deployment and environment support for modern web operations.',
    focusCreative: 'Core competency: brand execution assets that support marketing and product storytelling.',
  },
  contact: {
    title: 'Get In Touch',
    description: "Ready to transform your business? Send us a message and we'll get back to you within 24 hours.",
    name: 'Name',
    namePlaceholder: 'Your name',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    reason: 'Reason for Contact',
    reasonPlaceholder: 'Select a reason',
    message: 'Message',
    messagePlaceholder: 'How can we help you?',
    sending: 'Sending...',
    send: 'Send Message',
    successTitle: 'Message Sent!',
    successText: "Thank you for reaching out. We'll get back to you soon.",
    sendAnother: 'Send Another Message',
    recaptchaError: 'Please complete the reCAPTCHA verification.',
    submitError: 'Submission failed. Please try again or email us directly.',
    reasons: {
      incorporationServices: 'Incorporation Services',
      aiSolutions: 'AI Solutions',
      b2bSolutions: 'B2B Solutions',
      marketingStrategy: 'Marketing Strategy',
      businessSoftware: 'Business Software',
      brandDesign: 'Brand Design',
      businessConsulting: 'Business Consulting',
      websiteDevelopment: 'Website Development',
      websiteSupport: 'Website Support / Maintenance',
      ecommerceSupport: 'Ecommerce Support',
      generalQuestion: 'General Question',
      partnership: 'Partnership Opportunity',
    },
  },
  footer: {
    tagline: 'Transforming business operations through innovation and excellence.',
    quickLinks: 'Quick Links',
    starModels: 'Star Models',
    legal: 'Legal',
    termsConditions: 'Terms & Conditions',
    privacyPolicy: 'Privacy Policy',
    contactTitle: 'Contact',
    city: 'London, ON',
    country: 'Canada',
    rightsReserved: 'Impresstars. All rights reserved.',
    notALawFirm: 'Impresstars is not a law firm and does not provide legal advice.',
  },
  notFound: {
    title: 'Page Not Found',
    metaDescription: "The page you're looking for doesn't exist or has moved.",
    heading: 'Page Not Found',
    text: "The page you're looking for doesn't exist or may have moved. Let's get you back on track.",
    backHome: 'Back to Home',
    contactUs: 'Contact Us',
    portfolio: 'Portfolio',
    services: 'Services',
  },
  caseStudy: {
    notFound: 'Case Study Not Found',
    returnHome: 'Return to Home',
    backToPortfolio: 'Back to Portfolio',
    client: 'Client:',
    challenge: 'The Challenge',
    solution: 'Our Solution',
    keyResults: 'Key Results',
    technologiesUsed: 'Technologies Used',
    visitProject: 'Visit Project',
    items: {
      cleaningEdgePlatform: {
        title: 'Cleaning EDGE Platform',
        category: 'Web Development',
        client: 'Cleaning EDGE',
        description: 'A comprehensive digital platform for managing cleaning services, including scheduling, team management, and customer feedback.',
        challenge: 'The client needed a scalable solution to manage their growing cleaning service operations, handle customer bookings, and optimize team scheduling across multiple locations.',
        solution: 'We developed a custom web platform that integrates booking management, team scheduling, and real-time tracking. The solution includes a customer portal, admin dashboard, and mobile-friendly interface for cleaning teams.',
        results: [
          'Reduced scheduling conflicts by 95%',
          'Increased customer satisfaction rate to 98%',
          'Improved team efficiency by 40%',
          'Enabled expansion to 3 new locations',
        ],
      },
      aiAnalyticsDashboard: {
        title: 'AI-Powered Analytics Dashboard',
        category: 'AI Solutions',
        client: 'TechVision Inc.',
        description: 'Custom analytics dashboard using machine learning to predict business trends and optimize operations.',
        challenge: 'The client struggled to make sense of their vast data collection and needed predictive insights to make better business decisions.',
        solution: 'We implemented a machine learning system that analyzes historical data, predicts trends, and provides actionable insights through an intuitive dashboard interface.',
        results: [
          'Increased prediction accuracy by 85%',
          'Reduced decision-making time by 60%',
          'Generated $2M in cost savings',
          'Improved inventory management by 45%',
        ],
      },
      globalMarketingCampaign: {
        title: 'Global Marketing Campaign',
        category: 'Marketing Strategy',
        client: 'Global Solutions Ltd',
        description: "Comprehensive digital marketing strategy that increased client's market presence across three continents.",
        challenge: 'The client needed to expand their market presence globally while maintaining consistent brand messaging and engagement across different cultural contexts.',
        solution: 'We developed a multi-channel marketing strategy with localized content, targeted advertising, and cultural adaptation of marketing materials.',
        results: [
          'Reached 2M+ new potential customers',
          'Increased global sales by 150%',
          'Improved brand recognition by 80%',
          'Generated 300% ROI on marketing spend',
        ],
      },
      hauntedGalleria: {
        title: 'Haunted Galleria',
        category: 'Web Design & Development',
        client: 'Haunted Galleria',
        description: 'An immersive, dark-themed showcase website for a haunted gallery experience — blending atmospheric visuals, eerie animations, and bold typography.',
        challenge: 'The client needed a web presence that matched the dramatic, mysterious nature of their haunted gallery concept — one that felt genuinely unsettling and memorable.',
        solution: 'We crafted a fully custom site with dark ambient aesthetics, layered parallax effects, and horror-inspired typography to build suspense and intrigue.',
        results: [
          'Created a stand-out brand identity in a niche market',
          'Immersive UX that keeps visitors engaged longer',
          'Fully responsive across all devices',
          'Optimized for fast load times despite rich visual effects',
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: 'Incorporation Services',
      metaDescription: "Start your business journey with confidence. Our incorporation services provide a solid foundation for your company's future success.",
      intro: 'Start your business journey with confidence. Our incorporation services provide a solid foundation for your company\'s future success.',
      disclaimer: 'Disclaimer: Impresstars is not a law firm and does not provide legal advice. We recommend consulting a qualified attorney for legal guidance.',
      structureOptions: 'Business Structure Options',
      structureItems: [
        'Limited Liability Company (LLC)',
        'Corporation (C-Corp, S-Corp)',
        'Non-Profit Organization',
        'Partnership Formations',
      ],
      included: "What's Included",
      includedItems: [
        'Business Name Search',
        'Articles of Incorporation',
        'EIN Registration',
        'Operating Agreement',
      ],
      ctaTitle: 'Ready to Incorporate?',
      ctaText: "Let's discuss the best structure for your business and get you started on the right path.",
      ctaButton: 'Schedule a Consultation',
    },
    aiSolutions: {
      title: 'AI Solutions',
      metaDescription: 'Transform your business with cutting-edge artificial intelligence solutions tailored to your specific needs.',
      intro: 'Transform your business with cutting-edge artificial intelligence solutions tailored to your specific needs.',
      servicesTitle: 'AI Services',
      servicesItems: [
        'Machine Learning Models',
        'Natural Language Processing',
        'Computer Vision Solutions',
        'Predictive Analytics',
      ],
      implAreas: 'Implementation Areas',
      implItems: [
        'Customer Service Automation',
        'Data Analysis & Insights',
        'Process Optimization',
        'Decision Support Systems',
      ],
      ctaTitle: 'Ready to Implement AI?',
      ctaText: "Let's explore how AI can revolutionize your business operations and drive growth.",
      ctaButton: 'Get Started',
    },
    b2bSolutions: {
      title: 'B2B Solutions',
      metaDescription: 'Optimize your business-to-business operations with our comprehensive solutions designed for modern enterprises.',
      intro: 'Optimize your business-to-business operations with our comprehensive solutions designed for modern enterprises.',
      coreServices: 'Core Services',
      coreServicesItems: [
        'Supply Chain Optimization',
        'Partnership Development',
        'Process Outsourcing',
        'Strategic Planning',
      ],
      benefits: 'Benefits',
      benefitsItems: [
        'Increased Efficiency',
        'Cost Reduction',
        'Market Expansion',
        'Revenue Growth',
      ],
      ctaTitle: 'Transform Your B2B Operations',
      ctaText: "Let's optimize your business relationships and processes for maximum efficiency.",
      ctaButton: 'Contact Us',
    },
    marketingStrategy: {
      title: 'Marketing Strategy',
      metaDescription: 'Develop a powerful marketing strategy that drives growth and connects with your target audience.',
      intro: 'Develop a powerful marketing strategy that drives growth and connects with your target audience.',
      strategyComponents: 'Strategy Components',
      strategyItems: [
        'Market Analysis',
        'Competitor Research',
        'Target Audience Profiling',
        'Channel Strategy',
      ],
      deliverables: 'Deliverables',
      deliverablesItems: [
        'Marketing Plan',
        'Content Strategy',
        'Campaign Roadmap',
        'ROI Projections',
      ],
      ctaTitle: 'Ready to Grow?',
      ctaText: "Let's create a marketing strategy that takes your business to the next level.",
      ctaButton: 'Start Planning',
    },
    brandDesign: {
      title: 'Brand Design',
      metaDescription: 'Create a memorable brand identity that resonates with your audience and stands out in the market.',
      intro: 'Create a memorable brand identity that resonates with your audience and stands out in the market.',
      designServices: 'Design Services',
      designItems: [
        'Logo Design',
        'Brand Guidelines',
        'Visual Identity',
        'Marketing Materials',
      ],
      deliverables: 'Deliverables',
      deliverablesItems: [
        'Brand Style Guide',
        'Logo Package',
        'Color Palette',
        'Typography System',
      ],
      ctaTitle: 'Ready for a New Look?',
      ctaText: "Let's create a brand identity that captures your vision and connects with your audience.",
      ctaButton: 'Start Design Process',
    },
    businessConsulting: {
      title: 'Business Consulting',
      metaDescription: 'Get expert guidance to optimize your operations and accelerate business growth through proven methodologies.',
      intro: 'Get expert guidance to optimize your operations and accelerate business growth through proven methodologies.',
      consultingAreas: 'Consulting Areas',
      consultingItems: [
        'Strategic Planning',
        'Operations Optimization',
        'Financial Analysis',
        'Growth Strategy',
      ],
      benefits: 'Benefits',
      benefitsItems: [
        'Improved Efficiency',
        'Cost Reduction',
        'Revenue Growth',
        'Better Decision Making',
      ],
      ctaTitle: 'Ready to Optimize?',
      ctaText: "Let's analyze your business and create a roadmap for sustainable growth.",
      ctaButton: 'Book Consultation',
    },
    businessSoftware: {
      title: 'Business Software Solutions',
      metaDescription: 'Transform your business operations with carefully selected and implemented software solutions that streamline processes and boost efficiency.',
      intro: 'Transform your business operations with carefully selected and implemented software solutions that streamline processes and boost efficiency.',
      ourApproach: 'Our Approach',
      approachItems: [
        'Business Process Analysis',
        'Software Requirements Gathering',
        'Solution Evaluation & Selection',
        'Implementation & Integration',
      ],
      solutionAreas: 'Solution Areas',
      solutionItems: [
        'ERP Systems',
        'CRM Platforms',
        'Project Management Tools',
        'Custom Software Development',
      ],
      ctaTitle: 'Ready to Optimize Your Operations?',
      ctaText: "Let's identify the perfect software solutions to transform your business processes.",
      ctaButton: 'Schedule Consultation',
    },
  },
  seo: {
    homeTitle: "Building Tomorrow's Business Excellence",
    homeDescription: "Impresstars orchestrates high-performance business operations through our innovative Star Model system. From incorporation to growth strategy, we're your partner in operational excellence.",
    portfolioTitle: 'Portfolio',
    portfolioDescription: 'Explore our complete collection of successful projects and case studies across various industries.',
    partnersTitle: 'Recommended Tools & Partners',
    partnersDescription: 'Tools and platforms Impresstars uses and recommends for clients. Get started with best-in-class technology through our referral links.',
  },
  languageSwitcher: {
    label: 'Language',
  },
} as const;

export type Translations = typeof en;
